import { takeLatest, call, put } from 'redux-saga/effects';
import client from 'utils/contentfulService';
import { GET_DISCLAIMER } from './constants';
import { getDisclaimerSuccess, processing } from './actions';

function* getDisclaimerSaga({ payload }) {
  const { type } = payload;
  try {
    yield put(processing(true));
    const response = yield call(() =>
      client.getEntries({
        content_type: 'siteCopy',
        'fields.slug[in]': type,
        include: 2,
      }),
    );
    yield put(getDisclaimerSuccess(response));
  } catch (error) {
    // handle error here
  } finally {
    yield put(processing(false));
  }
}

// Individual exports for testing
export default function* defaultSaga() {
  yield takeLatest(GET_DISCLAIMER, getDisclaimerSaga);
}
